import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UploadComponent } from './upload.component';
import { NgxUploaderModule } from 'ngx-uploader';

@NgModule({
  declarations: [
    UploadComponent
  ],
  imports: [
    IonicPageModule.forChild(UploadComponent),
    NgxUploaderModule
  ],
  exports: [
    UploadComponent
  ]
})
export class UploadComponentModule {}



// WEBPACK FOOTER //
// ./src/components/file-upload/file-upload.module.ts